import moment from 'moment'
import config from '../../config'

export const selectVolvo = (sections) => {
  const volvoSection = sections.find(section => section.id === config.volvoSectionId)
  return {
    icon: volvoSection.icon,
    url: `/sections/${volvoSection.id}`
  }
}

export const selectLicenceNumbers = (user) => user.licences.map(licence => licence.licence_id)

export const selectArticlesForLanguage = (articles, langId) => articles.filter(article => article.language_id === langId)

export const selectNews = (state) => {
  const pagination = state.content.pagination
  const from = (pagination.page - 1) * config.pagination.perPage
  const to = from + config.pagination.perPage

  const news = state.content.articles
    .filter(article => article.section_id === config.newsSectionId)
    .filter(article => article.language_id === state.locale.selectedLanguage.id)
    .sort((a, b) => moment(b.created_at).diff(moment(a.created_at)))

  return {
    news: news.slice(from, to),
    total: news.length,
  }
}

export const selectNewsTotal = (state) => {
  return state.content.articles
    .filter(article => article.section_id === config.newsSectionId)
    .filter(article => article.language_id === state.locale.selectedLanguage.id)
    .length
}
